import type { ResolverInput, ResolverResult } from './types';

// §1.1: migrated to RPC. has_payment_received now checks
// invoices.status = 'paid' AND stripe_payment_intent_id IS NOT NULL.
// Manual mark-as-paid completes the invoice lifecycle but does not complete
// the terminal milestone — the milestone requires a real Stripe payment to
// prove the payment pipeline works. See Session 27 migration 125 for the
// fraud-vector rationale.
export async function resolveReceiveFirstPaymentItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_payment_received) return { complete: true, reason: 'stripe payment received' };
  return { complete: false, reason: 'no stripe payment received yet' };
}
